import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const BulletListIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue241'}</MuiIcon>
        );
    })